


















import {Component, Prop, Vue} from 'vue-property-decorator'
import {currency} from "@/util/formatter";

@Component
export default class TaxYearSummary extends Vue {
    @Prop()
    balance!: number;

    @Prop()
    tax!: number;

    private get formattedBalance(): string {
        return currency(Math.abs(this.balance));
    }

    private get balanceClass(): string {
        return this.balance >= 0 ? 'text-green' : 'text-red';
    }

    private get balanceTypeText(): string {
        return this.balance >= 0 ? 'profit' : 'loss';
    }

    private get formattedTax(): string {
        return currency(this.tax);
    }
}
